import {useDispatch, useSelector} from "react-redux";
import React, {useEffect} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {blogContentValidityCheck} from "../../../helpers/helperFunctions";
import {MIN_CONTENT_NEEDED_IN_BLOGS} from "../constants";
import {
  resetManageBlogs,
  setManageBlogModals,
  setShowTips,
  tryLoadBlogDetail
} from "../../../redux/slices/manageBlogSlice";
import {resetAllSearch} from "../../../redux/slices/searchSlice";
import {ButtonTertiary, SemiTransparentButton} from "../../../components/CustomButton";
import CustomIcon from "../../../components/CustomIcon";

const PublishBlogButton = React.memo(() => {


  const dispatch = useDispatch();
  const navigate = useNavigate();
  const blogContents = useSelector((state) => state.manageBlogs.create.content);

  const {init, data} = useSelector((state) => state.manageBlogs.create.details);
  const title = useSelector((state) => state.manageBlogs.create.mainTitle);
  const isPublished = useSelector((state) => state.manageBlogs.create.published);
  const {blog_id: blogId} = useParams();

  const validity = blogContentValidityCheck(blogContents.blocks ?? []);

  const isContentsInvalid = validity.valid.length < MIN_CONTENT_NEEDED_IN_BLOGS || !!validity.invalid.length || !title?.trim();

  useEffect(() => {

    if (blogId) {
      dispatch(tryLoadBlogDetail({id: blogId}));
    }


    return () => {
      //todo clear search
      dispatch(resetManageBlogs());
      dispatch(resetAllSearch());
      dispatch(tryLoadBlogDetail({clear: true}));
    };
  }, []);

  useEffect(() => {
    if (isPublished) {
      navigate('/blogs');
    }

  }, [isPublished]);


  const onPublish = async () => {
    if (isContentsInvalid) {
      dispatch(setShowTips({show: true}));
    } else {
      dispatch(setManageBlogModals(blogId ? {modal: true, data, ext: true} : {modal: true, ext: true}));
    }

  };

  return (
    <ButtonTertiary onClick={onPublish} disabled={!init && blogId}>
      Publish
    </ButtonTertiary>
  );
});

export default PublishBlogButton;

export const BlogInfoButton = () => {
  const dispatch = useDispatch();
  return (
    <SemiTransparentButton isIconButton="true" className="flex space-x-1"
                           onClick={() => dispatch(setShowTips({show: true}))}>
      <CustomIcon size="xl" className="cursor-pointer"
                  icon="info"/>
      <span>Info</span>
    </SemiTransparentButton>
  );
};